import axios from 'axios';
import { useEffect, useState } from 'react';
import { getTemplateData } from '../../helpers/quokka_template_defaults_editor/templates_data_helpers';

// Saves a local copy of templatesData that is updated based on the changes
// performed in the editor that lives in quokka
const useTemplatesData = (initialTemplatesData, propertyType) => {
  const [templatesData, setTemplatesData] = useState(initialTemplatesData);

  const updateOptionsEditorCfg = (newOptionsEditorCfg) => {
    const updatedData = newOptionsEditorCfg.data;

    if (propertyType === 'sale') {
      newOptionsEditorCfg.saleData = {
        ...newOptionsEditorCfg.saleData,
        defaultOptions: updatedData.defaultOptions,
        sectionOrder: updatedData.sectionOrder
      };
    } else if (propertyType === 'lease') {
      newOptionsEditorCfg.leaseData = {
        ...newOptionsEditorCfg.leaseData,
        defaultOptions: updatedData.defaultOptions,
        sectionOrder: updatedData.sectionOrder
      };
    }

    return newOptionsEditorCfg;
  };

  // Effect to handle changes done in the quokka side by the template options editor
  useEffect(() => {
    const handleQuokkaOptionsChanged = (e) => {
      if (e.data[0] !== 'quokka-options-changed') return;
      const templateId = e.data[1].templateId;

      if (!templateId) return;

      const templateData = getTemplateData(templatesData, templateId);
      const optionsEditorCfg = templateData && templateData.optionsEditorCfg;

      axios.post(optionsEditorCfg.data.optionsUpdateOrCreateUrl,
        { options: e.data[1].options, sectionOrder: e.data[1].sectionOrder, propertyType: propertyType })
        .then(() => {
          const newTemplateData = {
            ...templateData,
            optionsEditorCfg: {
              ...optionsEditorCfg,
              data: {
                ...optionsEditorCfg.data,
                defaultOptions: e.data[1].options,
                sectionOrder: e.data[1].sectionOrder
              }
            }
          };


          const templateDataToEditIndex = (templatesData || []).indexOf(templateData);
          const newTemplatesData = [...templatesData];
          newTemplatesData[templateDataToEditIndex] = newTemplateData;

          newTemplatesData[templateDataToEditIndex].optionsEditorCfg = updateOptionsEditorCfg(
            newTemplatesData[templateDataToEditIndex].optionsEditorCfg
          );

          setTemplatesData(newTemplatesData);
        });
    };

    window.addEventListener('message', handleQuokkaOptionsChanged);

    return () => window.removeEventListener('message', handleQuokkaOptionsChanged);

    // Register only once. This handles updates for any template updated
  }, [propertyType]);

  return templatesData;
};

export default useTemplatesData;